// extracted by mini-css-extract-plugin
export default {"wrapper":"in-z","response":"jn-z","error":"kn-z","disabled":"ln-z","buttons":"mn-z","feedbackQuestionSection":"nn-z","yesNoWrapper":"on-z"};